<template>
  <div>
    <el-dialog
    title="跟进记录"
    :visible.sync="dialogVisible"
    width="960px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <!-- 客户信息卡片 -->
    <el-card shadow="never" style="margin-bottom: 16px">
      <div class="header"><div class="tit">客户信息</div></div>
      <el-row :gutter="20">
        <el-col :span="10">
          <div class="info-item">
            <span class="info-label">客户名称：</span>
            <span class="info-value">{{ schoolInfo.schoolName || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-item">
            <span class="info-label">负责人：</span>
            <span class="info-value">{{ schoolInfo.userName || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="info-label">赛区：</span>
            <span class="info-value">{{ schoolInfo.districtName || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="info-item">
            <span class="info-label">客户类型：</span>
            <span class="info-value">{{ schoolTypeFilter(schoolInfo.schoolType) || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-item">
            <span class="info-label">参赛类型：</span>
            <span class="info-value">{{ schoolInfo.typeflagName || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="info-label">参赛经历：</span>
            <span class="info-value">{{ schoolInfo.attendTypeName || '-' }}</span>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="info-item">
            <span class="info-label">联系地址：</span>
            <span class="info-value">{{ schoolInfo.address || '-' }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 赛季筛选 + 跟进记录列表 -->
    <el-card shadow="never">
      <div class="header">
        <div class="a">
          <span class="tit">跟进记录</span>
          <div>
            <span>赛季</span>
            <el-select v-model="querySeason" placeholder="请选择赛季" size="small" style="width: 200px; margin-left: 10px;" @change="handleSeasonChange">
              <el-option
                  v-for="item in seasonList"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
              ></el-option>
            </el-select>
            <el-tag size="small" effect="plain" style="margin-left: 12px;" :type="guestStatusTagType(infoGuestStatus)">{{ guestStatusFilter(infoGuestStatus) }}</el-tag>
          </div>
        </div>
        <el-button class="btn" size="mini" plain type="success" @click="openTrackForm">新增跟进记录</el-button>
      </div>
      <el-table :data="recordList" border stripe v-loading="loading" size="small">
        <el-table-column label="序号" type="index" width="60px"></el-table-column>
        <el-table-column label="跟进人" min-width="120">
          <template slot-scope="scope">{{ scope.row.erpUser && scope.row.erpUser.userName || '-' }}</template>
        </el-table-column>
        <el-table-column label="跟进时间" prop="happenTime" min-width="160"></el-table-column>
        <el-table-column label="跟进内容" prop="content" min-width="300" show-overflow-tooltip></el-table-column>
        <el-table-column label="联系人" prop="name" min-width="120"></el-table-column>
      </el-table>
      <el-pagination
        v-if="total > 0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total"
        style="margin-top: 12px"
      ></el-pagination>
      <!-- 无数据 -->
      <!-- <div v-if="!loading && recordList.length === 0" style="text-align: center; color: #999; padding: 20px 0">
        暂无跟进记录
      </div> -->
    </el-card>
    </el-dialog>

    <!-- 新增跟进记录表单弹窗 -->
    <el-dialog title="新增跟进记录" :visible.sync="trackDialogVisible" width="520px" :close-on-click-modal="false" append-to-body>
    <el-form :model="trackForm" label-width="100px" ref="trackFormRef">
      <el-form-item label="客单状态" prop="guestStatus">
        <el-select v-model="trackForm.guestStatus" placeholder="请选择状态" style="width: 100%">
          <el-option label="待跟进" :value="-1"></el-option>
          <el-option label="跟进中" :value="1"></el-option>
          <el-option label="已参赛" :value="2"></el-option>
          <el-option label="已拒绝" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="约谈方式" prop="interviewMethod">
        <el-select v-model="trackForm.interviewMethod" placeholder="请选择方式" style="width: 100%">
          <el-option label="微信" :value="1"></el-option>
          <el-option label="电话" :value="2"></el-option>
          <el-option label="线下见面" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="参加赛事" prop="participateArr">
        <el-select v-model="trackForm.participateArr" placeholder="请选择赛事" style="width: 100%">
          <el-option label="SPBCN" value="SPBCN"></el-option>
          <el-option label="ITSO" value="ITSO"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人" prop="name">
        <el-input v-model="trackForm.name" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="跟进内容" prop="content">
        <el-input type="textarea" v-model="trackForm.content" placeholder="请输入跟进内容" :rows="4"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="trackDialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="trackLoading" @click="submitTrack">保 存</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SchoolTrackRecordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    },
    schoolTypeList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dialogVisible: false,
      trackDialogVisible: false,
      trackLoading: false,
      loading: false,
      schoolInfo: {},
      recordList: [],
      seasonList: [],
      querySeason: this.$chnEngStatusCode.defaultSeason,
      total: 0,
      queryForm: {
        pageNum: 1,
        pageSize: 10
      },
      trackForm: {
        guestStatus: '',
        interviewMethod: '',
        participateArr: '',
        name: '',
        content: ''
      },
      info: {},
      infoGuestStatus: ''
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (val) {
        this.initData()
      }
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    schoolTypeFilter (val) {
      const item = this.schoolTypeList.find((s) => String(s.dictValue) === String(val))
      return item ? item.dictLabel : '未知'
    },
    // 初始化数据
    initData () {
      this.buildSchoolInfo()
      this.recordList = []
      this.total = 0
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10
      this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.seasonList = value })
      this.getRecordList()
    },
    // 构建客户信息
    buildSchoolInfo () {
      const school = this.row.school || {}
      this.schoolInfo = {
        schoolName: school.schoolName || '-',
        userName: (this.row.recipientUser && this.row.recipientUser.userName) || '-',
        districtName: school.districtName || '-',
        schoolType: school.schoolType,
        typeflagName: school.typeflagName || this.typeflagFilter(school.typeflag) || '-',
        attendTypeName: school.attendTypeName || this.attendTypeFilter(school.attendType) || '-',
        address: this.formatAddress(school)
      }
    },
    // 赛季变更
    handleSeasonChange () {
      this.queryForm.pageNum = 1
      this.getRecordList()
    },
    // 获取跟进记录
    getRecordList () {
      if (!this.querySeason) {
        this.recordList = []
        this.total = 0
        return
      }
      this.loading = true
      const params = {
        schoolId: this.row.schoolId ? this.row.schoolId : this.row.school ? this.row.school.id : '',
        season: this.querySeason,
        pageNum: this.queryForm.pageNum,
        pageSize: this.queryForm.pageSize
      }
      this.$http.get('schoolTrack/getInfoBySchoolId', { params }).then((res) => {
        if (res.code === 200) {
          const list = res.data.schoolTrackLogs || []
          this.recordList = list.map((item) => ({
            ...item,
            guestStatusName: this.guestStatusFilter(item.guestStatus)
          }))
          this.info = res.data
          this.infoGuestStatus = res.data.guestStatus !== undefined ? res.data.guestStatus : ''
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.$message.error('获取跟进记录失败')
      })
    },
    // 地址拼接
    formatAddress (row) {
      if (!row) return '-'
      const areaStr = [row.province, row.city, row.area].filter((v) => v).join('')
      return areaStr + (row.schoolAddress || '')
    },
    // 客单状态映射
    guestStatusFilter (val) {
      const map = {
        '-1': '待跟进',
        1: '跟进中',
        2: '已参赛',
        3: '已拒绝'
      }
      return map[String(val)] || '未知'
    },
    guestStatusTagType (val) {
      console.log(val)
      const map = {
        '-1': 'warning',
        1: '',
        2: 'success',
        3: 'danger'
      }
      return map[String(val)] || ''
    },
    // 参赛类型映射
    typeflagFilter (val) {
      const map = { 0: '非集体参赛', 1: '集体参赛' }
      return map[val] !== undefined ? map[val] : null
    },
    // 参赛经历映射
    attendTypeFilter (val) {
      const map = { 0: '有参赛经历', 1: '无参赛经历' }
      return map[val] !== undefined ? map[val] : null
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getRecordList()
    },
    handleCurrentChange (newPage) {
      this.queryForm.pageNum = newPage
      this.getRecordList()
    },
    handleClose () {
      this.recordList = []
      this.schoolInfo = {}
    },
    // 打开新增跟进记录表单
    openTrackForm () {
      this.trackForm = {
        guestStatus: '',
        interviewMethod: '',
        participateArr: '',
        name: '',
        content: ''
      }
      this.$nextTick(() => {
        this.$refs.trackFormRef && this.$refs.trackFormRef.resetFields()
      })
      this.trackDialogVisible = true
    },
    // 提交新增跟进记录
    submitTrack () {
      if (!this.trackForm.guestStatus) {
        this.$message.warning('请选择客单状态')
        return
      }
      if (!this.trackForm.interviewMethod) {
        this.$message.warning('请选择约谈方式')
        return
      }
      // if (!this.trackForm.participateArr) {
      //   this.$message.warning('请选择参加赛事')
      //   return
      // }
      if (!this.trackForm.content) {
        this.$message.warning('请输入跟进内容')
        return
      }
      this.trackLoading = true
      const params = {
        content: this.trackForm.content,
        guestStatus: this.trackForm.guestStatus,
        interviewMethod: this.trackForm.interviewMethod,
        name: this.trackForm.name,
        participateArr: this.trackForm.participateArr,
        schoolId: this.row.schoolId || (this.row.school && this.row.school.id),
        schoolTrackId: this.row.id,
        happenTime: new Date().getTime()
      }
      this.$http.post('schoolTrack/createTrack', params).then((res) => {
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.trackDialogVisible = false
          this.getRecordList()
        } else {
          this.$message.error(res.msg || '保存失败')
        }
        this.trackLoading = false
      }).catch(() => {
        this.trackLoading = false
        this.$message.error('保存失败')
      })
    }
  }
}
</script>

<style scoped>
.info-item {
  line-height: 28px;
  font-size: 14px;
  margin: 8px 0;
}
.info-label {
  color: #909399;
}
.info-value {
  color: #303133;
}
.header{
  .tit{
    color: #1f30c7;
    font-size: 14px;
    font-weight: bold;
    margin-right: 20px;
  }
  .a{
    display: flex;
    align-items: center;
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
